var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('Nav',{staticClass:"nav",attrs:{"items":_vm.pages},on:{"nav":_vm.navigate}}),_c(_vm.page.component,{tag:"component",staticClass:"page",attrs:{"path":_vm.page.path},on:{"nav":_vm.navigate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }